module.exports = __webpack_public_path__ + "img/archiroidcom_wide.73e4ebc3.png";